import { render, staticRenderFns } from "./topR.vue?vue&type=template&id=a78f5c98&scoped=true"
import script from "./topR.vue?vue&type=script&lang=js"
export * from "./topR.vue?vue&type=script&lang=js"
import style0 from "./topR.vue?vue&type=style&index=0&id=a78f5c98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78f5c98",
  null
  
)

export default component.exports